import { Alert, CollapseProps, Typography } from 'antd'
import ColorProofIndicator from '../../../../components/color-proof-indicator/color-proof-indicator'
import AvailabilityIcon from '../../../schedules/flexo/components/cells/availability-icon'

const { Title } = Typography

export const helpItems: CollapseProps['items'] = [
    {
        key: '1',
        label: <b>Обзор раздела и выбор станка</b>,
        children: (
            <>
                <p>
                    Раздел «Печать» — рабочее место печатника. Здесь отображается очередь заданий
                    печати выбранного станка в том порядке, в котором их распределили в плане
                    печати.
                </p>
                <Title level={3}>Выбор станка</Title>
                <p>
                    При входе в раздел показываются карточки станков. Над карточками можно
                    отфильтровать станки по бренду (кнопка «Все» показывает все станки). Клик по
                    карточке открывает план этого станка, а его название появляется в заголовке
                    страницы.
                </p>
                <Alert
                    showIcon
                    message='Чтобы указать другой станок, выполните вход в систему повторно.'
                    type='info'
                />
            </>
        ),
    },
    {
        key: '2',
        label: <b>Колонки плана</b>,
        children: (
            <>
                <ul>
                    <li>
                        <b>Номер</b> — номер задания печати. Иконка <ColorProofIndicator /> рядом с
                        номером означает, что отгрузка — цветопроба.
                    </li>
                    <li>
                        <b>Дата поставки</b> и <b>Клиент</b> — из отгрузки.
                    </li>
                    <li>
                        <b>Доп.</b> — при наведении показывает менеджера и дизайнера отгрузки.
                    </li>
                    <li>
                        <b>К</b> — тег «К» означает, что печать нужно проводить с куратором. При
                        наведении видно, какой куратор обрабатывал отгрузку.
                    </li>
                    <li>
                        <b>Тираж</b> — суммарный тираж всех видов отгрузки.
                    </li>
                    <li>
                        <b>Материал</b> и <b>Метраж</b> — материал и расчётная длина материала на
                        тираж.
                    </li>
                    <li>
                        <b>Штамп / тубус</b> — номер штампа (со ссылкой на чертёж), номер тубуса и
                        размеры. Для отгрузок без высечки показывается виртуальный штамп.
                    </li>
                    <li>
                        <b>Вал</b> — вал штампа.
                    </li>
                    <li>
                        <b>Время тиража</b> — расчётное время печати.
                    </li>
                    <li>
                        <b>Примечание</b> — комментарий к заданию. Редактировать могут только Супер
                        Админ, Диспетчер заданий печати и Печатник, остальные видят его только для
                        чтения.
                    </li>
                </ul>
            </>
        ),
    },
    {
        key: '3',
        label: <b>Наличие и подготовка</b>,
        children: (
            <>
                <Title level={3}>Наличие (Ш / Ф / М)</Title>
                <p>Три колонки показывают наличие штампа (Ш), форм (Ф) и материала (М):</p>
                <ul>
                    <li>
                        <AvailabilityIcon display={{ inStock: true }} /> — в наличии;
                    </li>
                    <li>
                        <AvailabilityIcon display={{ waiting: 'Ожидается' }} /> — ожидается
                        (подробности при наведении);
                    </li>
                    <li>
                        <AvailabilityIcon display={{ problem: 'Проблема' }} /> — проблема
                        (подробности при наведении).
                    </li>
                </ul>
                <Title level={3}>Подготовка</Title>
                <p>
                    Зелёная галочка означает, что кладовщица в разделе «Подготовка к печати»
                    отметила: штамп, формы и бланк подготовлены к началу печати. Красный крестик —
                    подготовка ещё не завершена (отмечены не все три пункта).
                </p>
            </>
        ),
    },
    {
        key: '4',
        label: <b>Бланк</b>,
        children: (
            <>
                <p>Кнопка с иконкой глаза в колонке «Бланк» открывает производственный бланк.</p>
                <p>
                    На станках RG, если у отгрузки есть задача «Честный знак», рядом доступна кнопка
                    скачивания файла кодов «Честного знака».
                </p>
            </>
        ),
    },
    {
        key: '5',
        label: <b>Работа с печатью</b>,
        children: (
            <>
                <Title level={3}>Начать печать</Title>
                <p>
                    Кнопка «Начать печать» переводит задание в печать и закрепляет его за вами.
                    Кнопка недоступна, пока на станке есть другое незавершённое задание в печати (в
                    том числе на паузе).
                </p>
                <Title level={3}>Состояния кнопки</Title>
                <ul>
                    <li>
                        <b>Печатается</b> — задание сейчас печатаете вы.
                    </li>
                    <li>
                        <b>Занято</b> — задание сейчас печатает другой печатник.
                    </li>
                    <li>
                        <b>Пауза</b> и <b>Продолжить печать</b> — печать задания начата, но сейчас
                        никто его не печатает (например, после закрытия смены). Продолжить может
                        любой печатник.
                    </li>
                </ul>
                <Title level={3}>Завершить</Title>
                <p>В окне завершения выберите вариант:</p>
                <ul>
                    <li>
                        <b>Готово</b> — тираж напечатан: задание завершается и уходит из очереди
                        станка.
                    </li>
                    <li>
                        <b>Закрытие смены</b> — вы прекращаете работу, задание остаётся в печати и
                        встаёт на паузу. Следующий печатник продолжит его.
                    </li>
                </ul>
                <Alert
                    showIcon
                    message='После завершения не забудьте отправить фотоотчёт с номером задания в телеграм.'
                    type='info'
                />
                <Title level={3}>Отменить</Title>
                <p>
                    Отменяет задание печати. Нужно указать причину отмены, а для варианта «Другое» —
                    описать её.
                </p>
                <Alert
                    showIcon
                    message='«Завершить» и «Отменить» доступны только печатнику, который сейчас печатает это задание.'
                    type='warning'
                />
            </>
        ),
    },
    {
        key: '6',
        label: <b>Подсветка строк и обновление</b>,
        children: (
            <>
                <Title level={3}>Цвет строки</Title>
                <ul>
                    <li>
                        <b>Светло-голубой</b> — задание в печати.
                    </li>
                    <li>
                        <b>Светло-жёлтый</b> — задание на паузе.
                    </li>
                    <li>
                        <b>Светло-красный</b> — задание отменено.
                    </li>
                </ul>
                <Title level={3}>Обновление</Title>
                <p>
                    Список обновляется автоматически каждые несколько секунд, пока вкладка открыта и
                    активна. Перезагружать страницу не нужно.
                </p>
            </>
        ),
    },
]
